function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from "../../components";
import DotLeader from "./DotLeader";
export default function TableOfContentsRow({ section, rowIndex, style = {} }) {
    const { name, pageNumber } = section;
    return /*#__PURE__*/ _jsxs("div", {
        style: _object_spread({
            display: "flex",
            alignItems: "center"
        }, style),
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                children: `${rowIndex}. ${name}`
            }),
            pageNumber && /*#__PURE__*/ _jsx(DotLeader, {}),
            /*#__PURE__*/ _jsx(Typography, {
                children: pageNumber
            })
        ]
    }, pageNumber);
}
